import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class Group {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      name: '',
      reportId: '',
      principalTableId: '',
      referenceTableId: '',
      principalColumnId: '',
      referenceColumnId: '',
      // 区分归档表还是辅助表
      joinType: 'archived',
      use: true,
      type: null
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/join.js